const EVENTS = {
  CLICK_SHOP_CTA: 'clickShopCTA - CardCarousel',
  SCROLL_CAROUSEL: 'scrollCarousel - CardCarousel',
  WATCH_VIDEO: 'watchVideo - CardCarousel',
};

const CARD_TYPES = {
  CAROUSEL_CARD: 'carouselCard',
  VIDEO_CAROUSEL_CARD: 'carouselCardVideo',
  INFO_CAROUSEL_CARD: 'carouselCardInfo',
};

export { EVENTS, CARD_TYPES };
